import axios from "axios";
import http from "./http";
import commonData from "@/utils/commonData";
/**
 * Get请求
 * @param { String } url
 * @param { Object } params
 */
export function sendGet(url: string, params: object = {}): Promise<any> {
  const bpit_elk_api_start_time = new Date().getTime();
  return new Promise(async (resolve, reject) => {
    const res = await http.get(url, { params });
    if (bpit_elk_api_start_time) {
      const end_time = new Date().getTime();
      const load_time = end_time - bpit_elk_api_start_time;
      commonData(load_time, {
        api: url
      });
    }

    if (res && res.data) {
      resolve(res.data);
    } else {
      reject(res);
    }
  });
}

export function sendGetErr(url: string, params: object = {}): Promise<any> {
  const bpit_elk_api_start_time = new Date().getTime();
  return new Promise(async (resolve, reject) => {
    try {
      const res = await http.get(url, { params });
      if (bpit_elk_api_start_time) {
        const end_time = new Date().getTime();
        const load_time = end_time - bpit_elk_api_start_time;
        commonData(load_time, {
          api: url
        });
      }
      if (res) {
        resolve(res.data);
      } else {
        reject(res);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function sendGetMes(url: string, params: object = {}): Promise<any> {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await http.get(url, { params });
      if (res) {
        resolve(res);
      } else {
        reject(res);
      }
    } catch (error) {
      reject(error);
    }
  });
}

/**
 * Post 请求
 * @param { String } url
 * @param { Object } data
 */
export function sendPost(url: string, data: object): Promise<any> {
  const bpit_elk_api_start_time = new Date().getTime();
  return new Promise(async (resolve, reject) => {
    const res = await http.post(url, data);
    if (bpit_elk_api_start_time) {
      const end_time = new Date().getTime();
      const load_time = end_time - bpit_elk_api_start_time;
      commonData(load_time, {
        api: url
      });
    }
    if (res) {
      resolve(res.data);
    } else {
      reject(res);
    }
  });
}

export function sendPostErr(url: string, data: object): Promise<any> {
  const bpit_elk_api_start_time = new Date().getTime();
  return new Promise(async (resolve, reject) => {
    try {
      const res = await http.post(url, data);
      if (bpit_elk_api_start_time) {
        const end_time = new Date().getTime();
        const load_time = end_time - bpit_elk_api_start_time;
        commonData(load_time, {
          api: url
        });
      }
      // console.log(res, "eeeeeeeeeeeeee");
      if (res) {
        resolve(res.data);
      } else {
        reject(res);
      }
    } catch (error) {
      // console.log(error, "eeeeeeeeeeeeee");
      reject(error);
    }
  });
}
// 把res都返回回来，不止res.data
export function sendPostMes(url: string, data: object): Promise<any> {
  const bpit_elk_api_start_time = new Date().getTime();
  return new Promise(async (resolve, reject) => {
    try {
      const res = await http.post(url, data);
      if (bpit_elk_api_start_time) {
        const end_time = new Date().getTime();
        const load_time = end_time - bpit_elk_api_start_time;
        commonData(load_time, {
          api: url
        });
      }
      // console.log(res, "eeeeeeeeeeeeee");
      if (res) {
        resolve(res);
      } else {
        reject(res);
      }
    } catch (error) {
      // console.log(error, "eeeeeeeeeeeeee");
      reject(error);
    }
  });
}

/**
 * Put 请求
 * @param { String } url
 * @param { Object } data
 */

export function sendPut(url: string, data: object): Promise<any> {
  const bpit_elk_api_start_time = new Date().getTime();
  return new Promise(async (resolve, _) => {
    const res = await http.put(url, data);
    if (bpit_elk_api_start_time) {
      const end_time = new Date().getTime();
      const load_time = end_time - bpit_elk_api_start_time;
      commonData(load_time, {
        api: url
      });
    }
    if (res) {
      resolve(res.data);
    }
  });
}

export function sendPutErr(url: string, data: object): Promise<any> {
  const bpit_elk_api_start_time = new Date().getTime();
  return new Promise(async (resolve, reject) => {
    try {
      const res = await http.put(url, data);
      if (bpit_elk_api_start_time) {
        const end_time = new Date().getTime();
        const load_time = end_time - bpit_elk_api_start_time;
        commonData(load_time, {
          api: url
        });
      }
      if (res) {
        resolve(res.data);
      } else {
        reject(res);
      }
    } catch (error) {
      reject(error);
    }
  });
}

/**
 * Delete请求
 * @param { String } url
 * @param { Object } params
 */
export function sendDelete(url: string, params: object = {}): Promise<any> {
  const bpit_elk_api_start_time = new Date().getTime();
  return new Promise(async (resolve, _) => {
    const res = await http.delete(url, { params });
    if (bpit_elk_api_start_time) {
      const end_time = new Date().getTime();
      const load_time = end_time - bpit_elk_api_start_time;
      commonData(load_time, {
        api: url
      });
    }
    if (res) {
      resolve(res.data);
    }
  });
}

/**
 * All 请求
 * @param iterable 是一个可以迭代的参数如数组等
 * @param callback 要等到所有请求都完成才会执行
 */
export function sendAll(
  iterable: any[],
  callback: (value: any[]) => any
): Promise<any> {
  return new Promise(async (resolve, _) => {
    const res: any[] = await axios.all(iterable).then(axios.spread(callback));
    if (res.every(i => !!i)) {
      resolve(res.map(r => r.data));
    }
  });
}

//深度克隆
export const deepClone = function(obj: any, cache: any = []) {
  // 判断原对象是否存在
  // if (obj) {
  //     var newObj = JSON.parse(JSON.stringify(obj));
  //     return newObj;
  // }
  // just return if obj is immutable value
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  const hit = cache.find(c => c.original === obj);
  if (hit) {
    return hit.copy;
  }

  const copy = Array.isArray(obj) ? [] : {};
  cache.push({
    original: obj,
    copy
  });

  Object.keys(obj).forEach(key => {
    copy[key] = deepClone(obj[key], cache);
  });

  return copy;
};
